import React, { Component } from 'react';
import { Button, withStyles } from 'material-ui';
import Dictionary from '../../../../model/Dictionary';
import styles from './MealsSelectionStyles';
import MealsListProps from '../mealsList/MealsListProps';
import MealsSelectionController from './MealsSelectionController';
import ProgressBarCenter from '../../../../components/ProgressBarCenter';
import MealSwitch from '../../../../components/meals/mealSwitch/MealSwitch';
import TextField from '../../../../components/textField/TextField';
import MealsScreenController from '../../MealsScreenController';
import Constants from '../../../../model/AppConfiguration';

/**
 * ## Redux imports
 */
import * as passengersActions from '../../../../redux/actions/PassengersActions';
import * as flightsActions from '../../../../redux/actions/FlightsActions';
import * as globalActions from '../../../../redux/actions/GlobalActions';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import selectors from '../../../../redux/selectors/Index';
import MainController from '../../../../controllers/MainController';

class MealsSelection extends Component {
  static propTypes = MealsListProps;

  constructor (props) {
    super(props);

    const { reservationId, passengers, flights, actions } = props;
    let needsPassengers = MainController.showMobileVersion() ?
      reservationId :
      reservationId && (!passengers && !passengers.length);
    if (needsPassengers) {
      actions.getPassengers(reservationId);
    }

    this.state = {
      routeId: '',
      notes: '',
      checked: [ 0 ],
      passengers: passengers || [],
      selectedMeals: [],
      meals: [],
      flights: flights || [],
      appetizer: '',
      mainMeal: '',
      dessert: '',
      appetizerSubselection: '',
      mainMealSubselection: '',
      dessertSubselection: '',
    };

    this.selectPassenger = MealsSelectionController.selectPassenger.bind(this);
    this.onRouteIdChange = MealsSelectionController.onRouteIdChange.bind(this);
    this.getNameByType = MealsSelectionController.getNameByType.bind(this);
    this.getValueByType = MealsSelectionController.getValueByType.bind(this);
    this.getSubselectionByType = MealsSelectionController.getSubselectionByType.bind(this);
    this.onMealSelection = MealsSelectionController.onMealSelection.bind(this);
    this.onMealSubselection = MealsSelectionController.onMealSubselection.bind(this);
    this.updateMeals = MealsSelectionController.updateMeals.bind(this);

    this.onRouteIdChange(props);
  }

  componentDidMount () {
    let { flights, isFetching, reservationId, actions } = this.props;

    if (!isFetching && !flights) {
      actions.getFlights(Constants.REQUEST.MEALS, reservationId);
    }
  }

  componentWillReceiveProps (props) {
    let { flights, routeId, isFetching } = props;

    if (!isFetching && (routeId !== this.state.routeId || flights !== this.props.flights)) {
      this.onRouteIdChange(props);
    }
  }

  onChange = name => e => {
    this.setState({ [ name ]: e.target.value });
  };

  onDone = () => {
    const { selectedMeals } = this.state;
    const { activePassenger, actions, onConfirmationCallback } = this.props;
    let desktopContainer = document.getElementById('select-meals');
    if (desktopContainer) desktopContainer.scroll(0, 0);
    this.updateMeals();
    actions.changeActivePassenger(
      MealsScreenController.changePassenger(selectedMeals, activePassenger)
    );
    if (onConfirmationCallback) onConfirmationCallback();
  };

  render () {
    const { flights, meals, notes } = this.state;

    if (this.props.isFetching && !meals && (!flights && !flights.length)) {
      return <ProgressBarCenter />;
    }

    if (flights && !flights.length) {
      return <h3 style={{ margin: 30 }}>{Dictionary.flights.noFlightsAvailable}</h3>;
    }

    if (!meals || !meals.category || (meals.category && !meals.category.length)) {
      return <h3 style={{ margin: 30 }}>{Dictionary.meals.noMealsAvailable}</h3>;
    }

    return (
      <div>
        {meals.category.map((category, categoryIndex) => (
          <div key={`meals-category-${category.id}-${categoryIndex}`}>
            {category && category.label && category.items ? (
              <MealSwitch
                label={category.label}
                meals={category.items}
                value={this.getValueByType(category.label)}
                subselection={this.getSubselectionByType(category.label)}
                name={this.getNameByType(category.label)}
                onSelection={this.onMealSelection}
                onSubselection={this.onMealSubselection}
              />
            ) : null}
          </div>
        ))}
        <div style={{ padding: '0 20px' }}>
          <TextField
            label={Dictionary.meal.notes}
            onChange={this.onChange('notes')}
            name='notes'
            value={notes}
            placeholder={Dictionary.meal.notesPlaceholder}
          />
          <Button
            style={{ margin: '20px 0' }}
            variant='raised'
            fullWidth
            color='primary'
            onClick={this.onDone}
          >
            {Dictionary.meal.done}
          </Button>
        </div>
      </div>
    );
  }
}

/**
 * ## Redux boilerplate
 */
const actions = [ globalActions, passengersActions, flightsActions ];

function mapStateToProps (state) {
  let JSFlights = selectors.flights.getFlights(state.flights);
  return {
    isFetching: selectors.global.isFetching(state.global),
    reservationId: selectors.general.getReservationId(state.general),
    passengers: selectors.passengers.getPassengers(state.passengers),
    flights: selectors.flights.pairSeatsForPassengers(JSFlights),
  };
}

function mapDispatchToProps (dispatch) {
  const creators = Map()
    .merge(...actions)
    .filter(value => typeof value === 'function')
    .toObject();

  return {
    actions: bindActionCreators(creators, dispatch),
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(MealsSelection));



// WEBPACK FOOTER //
// ./src/containers/meals/common/mealsSelection/MealsSelection.js